const Reducer = (state, action) => {
  switch (action.type) {
    case 'FORM_REFRESH':
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        message: '',
      };
    case 'FORM_LOADING':
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: '',
      };

    case 'DATA_LOADING':
      let params = {
        loading: true,
        error: false,
        success: false,
        message: '',
      };
      if (action?.payload) params = { ...params, ...action.payload };
      return {
        ...state,
        ...params,
      };
    case 'FORM_POST_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: 'Error message!',
      };
    case 'FORM_POST_SUCCESS':
      return {
        ...state,
        ...action.payload.data,
        loading: false,
        error: false,
        success: true,
        message: 'Form Post Successfully.',
      };

    // GET
    case 'GET_DASHBOARD_DATA':
      return {
        ...state,
        dashboardData: action.payload,
      };
    case 'GET_MYPROPERTIES_DATA':
      return {
        ...state,
        loading: false,
        mypropertiesData: action.payload,
      };
    case 'GET_MYTENANCIES_DATA':
      return {
        ...state,
        mytenanciesData: action.payload,
      };
    case 'GET_MYOFFERS_DATA':
      return {
        ...state,
        myoffersData: action.payload,
      };
    case 'GET_MYAPPOINTMENTS_DATA':
      return {
        ...state,
        myappointmentsData: action.payload,
      };

    // Post
    case 'POST_APPOINTMENTS_SUCCESS':
      return {
        ...state,
        ...action.payload,
      };

    case 'GET_LATEST_PROPERTIES':
      return {
        ...state,
        latestProperties: action.payload,
      };

    case 'GET_ALL_PROPERTIES':
      return {
        ...state,
        allProperties: action.payload,
      };

    case 'GET_PROPERTY':
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        property: action.payload,
      };
    case 'GET_PROPERTY_FAILED':
      return {
        ...state,
        error: true,
      };
    default:
      return state;
  }
};

export default Reducer;
